export const creators = [
  {
    id: "liziqi",
    name: "李子柒",
    category: "传统文化",
    tier: "head",
    signature: "把田园生活过成诗意，也把东方手艺带向世界",
    description:
      "以慢节奏的田园影像记录传统手艺与四时耕作，从酿酒、织布到木工、造纸，画面考究、几乎没有台词，靠氛围与细节打动观众。适合喜欢安静叙事、想了解中国传统生活方式的人。",
    focus: ["传统手作", "田园生活", "美食酿造"],
    level: "头部创作者",
    cover:
      "https://readdy.ai/api/search-image?query=bamboo%20forest%20countryside%20scene%20with%20traditional%20Chinese%20handicraft%20tools%20on%20wooden%20table%2C%20warm%20natural%20light%2C%20muted%20earthy%20green%20tones%2C%20editorial%20lifestyle%20photography%2C%20serene%20atmosphere&width=640&height=400&seq=xigua-liziqi-cover&orientation=landscape",
    alt: "竹林中传统中式手作场景，暖色自然光",
  },
  {
    id: "huanong",
    name: "华农兄弟",
    category: "三农",
    tier: "head",
    signature: "用最朴素的镜头，记录最真实的南方乡村",
    description:
      "以轻松幽默的方式展示种植、养殖与乡村日常，把农活讲得像段子，既接地气又有信息量。适合想了解乡村生活、寻找松弛感内容的观众，也是很多人接触三农题材的入门账号。",
    focus: ["乡村生活", "种植养殖", "生活幽默"],
    level: "头部创作者",
    cover:
      "https://readdy.ai/api/search-image?query=rural%20village%20bamboo%20grove%20and%20small%20farmland%20in%20southern%20China%2C%20warm%20afternoon%20light%2C%20muted%20earthy%20tones%2C%20editorial%20documentary%20photography&width=640&height=400&seq=xigua-huanong-cover&orientation=landscape",
    alt: "南方乡村竹林与农田，暖色午后光线",
  },
  {
    id: "wanggang",
    name: "美食作家王刚",
    category: "美食",
    tier: "head",
    signature: "宽油、猛火、技术流，硬核烹饪教学",
    description:
      "以职业厨师视角拆解家常菜与宴席菜的做法，步骤清晰、火候讲得透，被很多观众当作可复现的烹饪教程。适合想认真学做菜、追求出品稳定的人。",
    focus: ["烹饪教学", "川菜", "后厨技巧"],
    level: "头部创作者",
    cover:
      "https://readdy.ai/api/search-image?query=professional%20Chinese%20restaurant%20kitchen%20wok%20cooking%20with%20fire%2C%20chef%20at%20work%2C%20warm%20dramatic%20light%2C%20editorial%20food%20photography&width=640&height=400&seq=xigua-wanggang-cover&orientation=landscape",
    alt: "专业中餐后厨猛火炒锅烹饪场景",
  },
  {
    id: "laofangu",
    name: "老饭骨",
    category: "美食",
    tier: "head",
    signature: "两位国宴大厨，把家常菜讲出讲究",
    description:
      "由资深大厨组合出镜，边做边讲菜品背后的门道与典故，把看似普通的家常菜做出层次。适合对饮食文化感兴趣、愿意琢磨细节的观众。",
    focus: ["家常菜", "饮食文化", "厨艺传承"],
    level: "头部创作者",
    cover:
      "https://readdy.ai/api/search-image?query=traditional%20Chinese%20home%20banquet%20dishes%20arranged%20on%20a%20wooden%20table%20with%20steaming%20bowls%2C%20warm%20inviting%20light%2C%20editorial%20food%20photography&width=640&height=400&seq=xigua-laofangu-cover&orientation=landscape",
    alt: "木质餐桌上的中式家宴菜品，热气与暖光",
  },
  {
    id: "wujingxiaoliang",
    name: "无穷小亮",
    category: "知识科普",
    tier: "head",
    signature: "用一张嘴鉴定万物，把博物知识讲得有趣",
    description:
      "以鉴定网络热门生物、辟谣与科普见长，语言风趣、知识密度高，常把冷门的自然博物知识讲成大众话题。适合喜欢轻松涨知识、对动植物感兴趣的观众。",
    focus: ["自然博物", "辟谣鉴定", "趣味科普"],
    level: "头部创作者",
    cover:
      "https://readdy.ai/api/search-image?query=natural%20history%20museum%20specimens%20and%20a%20microscope%20on%20a%20desk%2C%20warm%20library%20light%2C%20editorial%20still%20life%20photography&width=640&height=400&seq=xigua-wujingxiaoliang-cover&orientation=landscape",
    alt: "博物标本与显微镜静物场景，暖色书桌光",
  },
  {
    id: "guojierui",
    name: "我是郭杰瑞",
    category: "生活记录",
    tier: "head",
    signature: "以外国人视角观察中美生活差异",
    description:
      "用轻松的方式记录跨文化生活、饮食与消费差异，善于用对比引发讨论。适合对文化差异、海外生活感兴趣，想看轻松观察类内容的观众。",
    focus: ["跨文化", "生活观察", "美食体验"],
    level: "头部创作者",
    cover:
      "https://readdy.ai/api/search-image?query=city%20street%20corner%20in%20the%20morning%20with%20coffee%20and%20a%20notebook%2C%20cross-cultural%20urban%20lifestyle%2C%20warm%20light%2C%20editorial%20photography&width=640&height=400&seq=xigua-guojierui-cover&orientation=landscape",
    alt: "城市街角清晨咖啡与笔记本的生活场景",
  },
  {
    id: "daneng",
    name: "大能",
    category: "知识科普",
    tier: "quality",
    signature: "把钟表机械讲成故事的手艺人",
    description:
      "聚焦腕表与钟表机械，讲结构、讲历史也讲审美，语气克制、信息扎实。适合对腕表文化、机械美学感兴趣，想听点门道的观众。",
    focus: ["腕表文化", "机械美学", "器物科普"],
    level: "优质达人",
    cover:
      "https://readdy.ai/api/search-image?query=luxury%20watch%20mechanism%20macro%20detail%20on%20dark%20wood%20surface%2C%20warm%20golden%20light%2C%20editorial%20product%20photography&width=640&height=400&seq=xigua-daneng-cover&orientation=landscape",
    alt: "深色木面上腕表机芯微距细节，暖金色光",
  },
  {
    id: "sansongdaguo",
    name: "三宋大国",
    category: "美食",
    tier: "quality",
    signature: "走街串巷，把城市烟火气吃给你看",
    description:
      "以城市探店与地方小吃为主，记录有年头的小馆和街头摊档，兼顾味道与市井故事。适合想按图索骥找好吃、爱吃烟火气的观众。",
    focus: ["城市探店", "地方小吃", "市井生活"],
    level: "优质达人",
    cover:
      "https://readdy.ai/api/search-image?query=street%20food%20stall%20in%20a%20Chinese%20city%20at%20dusk%20with%20warm%20hanging%20lights%2C%20editorial%20documentary%20photography&width=640&height=400&seq=xigua-sansongdaguo-cover&orientation=landscape",
    alt: "城市街头小吃摊黄昏暖灯场景",
  },
  {
    id: "xudasao",
    name: "徐大sao",
    category: "美食",
    tier: "quality",
    signature: "大锅大灶里的乡村家常味道",
    description:
      "在农家灶台前做分量十足的家常菜，实诚、热闹，很有生活气息。适合喜欢家常硬菜、想看朴实做饭过程的观众。",
    focus: ["乡村家常", "大锅菜", "朴实美食"],
    level: "优质达人",
    cover:
      "https://readdy.ai/api/search-image?query=large%20rural%20farmhouse%20wok%20cooking%20over%20a%20firewood%20stove%2C%20warm%20rustic%20light%2C%20editorial%20food%20photography&width=640&height=400&seq=xigua-xudasao-cover&orientation=landscape",
    alt: "乡村土灶大锅柴火做饭场景",
  },
  {
    id: "maladezi",
    name: "麻辣德子",
    category: "美食",
    tier: "quality",
    signature: "麻辣鲜香的川味教程与家常创新",
    description:
      "围绕川味家常菜做详细演示，重口但好上手，常给出替换食材的实用建议。适合喜欢麻辣口味、想在家复刻川菜的观众。",
    focus: ["川味", "家常教程", "麻辣风味"],
    level: "优质达人",
    cover:
      "https://readdy.ai/api/search-image?query=spicy%20Sichuan%20dishes%20with%20chili%20and%20peppercorn%20on%20a%20rustic%20table%2C%20warm%20red%20tones%2C%20editorial%20food%20photography&width=640&height=400&seq=xigua-maladezi-cover&orientation=landscape",
    alt: "撒满辣椒与花椒的川味菜肴，暖红色调",
  },
  {
    id: "chuanxiang",
    name: "川乡小妹儿",
    category: "三农",
    tier: "quality",
    signature: "川渝乡村的四季日常与灶台烟火",
    description:
      "记录川渝乡下的农事与饮食，从地里的蔬菜到锅里的三餐，节奏舒缓、画面干净。适合向往乡野生活、喜欢慢节奏记录的人。",
    focus: ["乡村日常", "农事记录", "灶台美食"],
    level: "优质达人",
    cover:
      "https://readdy.ai/api/search-image?query=rural%20Sichuan%20farmhouse%20kitchen%20with%20fresh%20vegetables%20and%20a%20clay%20stove%2C%20warm%20daylight%2C%20editorial%20lifestyle%20photography&width=640&height=400&seq=xigua-chuanxiang-cover&orientation=landscape",
    alt: "川渝农家厨房里新鲜蔬菜与土灶",
  },
  {
    id: "ranchagege",
    name: "燃茶哥哥",
    category: "生活记录",
    tier: "quality",
    signature: "一人一车的摩旅与户外见闻",
    description:
      "骑行穿越山野与公路，记录沿途风景、食宿与人的故事，画面开阔、节奏自由。适合喜欢旅行、摩旅与户外题材的观众。",
    focus: ["摩旅", "公路旅行", "户外探险"],
    level: "优质达人",
    cover:
      "https://readdy.ai/api/search-image?query=motorcycle%20on%20a%20winding%20mountain%20road%20at%20golden%20hour%2C%20travel%20adventure%2C%20warm%20tones%2C%20editorial%20photography&width=640&height=400&seq=xigua-ranchagege-cover&orientation=landscape",
    alt: "金色时刻蜿蜒山路上的摩托车",
  },
  {
    id: "wanche",
    name: "玩车女神",
    category: "汽车",
    tier: "quality",
    signature: "专业视角的车型评测与用车科普",
    description:
      "以车型体验、对比与用车知识为主，讲得通俗，兼顾驾驶感受与实用建议。适合正在选车、想快速了解车型差异的观众。",
    focus: ["车型评测", "用车知识", "汽车科普"],
    level: "优质达人",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20car%20in%20a%20photography%20studio%20with%20warm%20ambient%20lighting%2C%20automotive%20editorial%20photography%2C%20muted%20tones&width=640&height=400&seq=xigua-wanche-cover&orientation=landscape",
    alt: "影棚暖光下的现代汽车",
  },
  {
    id: "amuliao",
    name: "阿木料理",
    category: "美食",
    tier: "rising",
    signature: "一人食也认真，厨房新手友好",
    description:
      "专注一人食与小份量料理，步骤简单、成本透明，很适合独居或刚开始下厨的人跟着做。内容更新稳定，互动氛围友好。",
    focus: ["一人食", "新手教程", "快手菜"],
    level: "潜力新人",
    cover:
      "https://readdy.ai/api/search-image?query=single-portion%20home%20cooked%20meal%20on%20a%20minimal%20wooden%20table%2C%20warm%20soft%20light%2C%20editorial%20food%20photography&width=640&height=400&seq=xigua-amuliao-cover&orientation=landscape",
    alt: "简约木桌上的一人食料理，柔和暖光",
  },
  {
    id: "huangyexiaoling",
    name: "荒野小灵",
    category: "户外",
    tier: "rising",
    signature: "野外生存技能与露营实操",
    description:
      "演示取火、搭建庇护所、野外辨别方向等实用技能，边做边讲原理。适合喜欢户外、露营，想积累实用经验的观众。",
    focus: ["野外生存", "露营技能", "户外实用"],
    level: "潜力新人",
    cover:
      "https://readdy.ai/api/search-image?query=wilderness%20camp%20with%20a%20tent%20and%20campfire%20at%20dusk%2C%20warm%20orange%20glow%2C%20outdoor%20editorial%20photography&width=640&height=400&seq=xigua-huangyexiaoling-cover&orientation=landscape",
    alt: "黄昏野外帐篷与篝火营地",
  },
  {
    id: "guonongxiaozhang",
    name: "果农小张",
    category: "三农",
    tier: "rising",
    signature: "从一颗果子讲清农业的门道",
    description:
      "记录果园种植的四季管理，讲品种、讲气候也讲销售，把农产品从田间到餐桌的过程讲明白。适合关注农业与产地故事的观众。",
    focus: ["果园种植", "农业科普", "产地故事"],
    level: "潜力新人",
    cover:
      "https://readdy.ai/api/search-image?query=orchard%20with%20ripe%20fruit%20baskets%20and%20green%20trees%2C%20warm%20afternoon%20sunlight%2C%20editorial%20agriculture%20photography&width=640&height=400&seq=xigua-guonongxiaozhang-cover&orientation=landscape",
    alt: "午后阳光下的果园与果篮",
  },
  {
    id: "shumaxiaorui",
    name: "数码小睿",
    category: "知识科普",
    tier: "rising",
    signature: "把数码参数翻译成大白话",
    description:
      "用通俗方式讲解手机、耳机等数码产品该怎么选，少堆参数、多讲实际体验。适合想买数码产品又不想看长评测的普通用户。",
    focus: ["数码测评", "选购指南", "体验分享"],
    level: "潜力新人",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20gadgets%20and%20devices%20neatly%20arranged%20on%20a%20desk%2C%20warm%20minimal%20light%2C%20editorial%20tech%20photography&width=640&height=400&seq=xigua-shumaxiaorui-cover&orientation=landscape",
    alt: "桌面整齐摆放的数码产品，暖色简约光",
  },
  {
    id: "zaizaiyangyang",
    name: "崽崽和洋洋",
    category: "亲子",
    tier: "rising",
    signature: "记录孩子成长的日常瞬间",
    description:
      "以亲子互动与成长记录为主，分享陪伴方式与育儿小经验，氛围温暖。适合新手父母或喜欢治愈系家庭内容的观众。",
    focus: ["亲子成长", "陪伴记录", "育儿分享"],
    level: "潜力新人",
    cover:
      "https://readdy.ai/api/search-image?query=parent%20and%20child%20playing%20together%20in%20a%20cozy%20sunlit%20living%20room%2C%20warm%20tones%2C%20editorial%20family%20lifestyle%20photography&width=640&height=400&seq=xigua-zaizaiyangyang-cover&orientation=landscape",
    alt: "阳光客厅里亲子互动的温暖场景",
  },
];